<template>
  <div
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu></user-menu>
      <template slot="links">
        <!-- 대시보드 탭 -->
        <sidebar-item
          :link="{
            name: $t('sidebar.dashboard'),
            icon: 'dashboard',
            path: '/dashboard',
          }"
        >
        </sidebar-item>

        <!-- 심사 관리 -->
        <sidebar-item
          v-if="hasRoles(['reviewer'])"
          :link="{ name: $t('sidebar.review_management'), icon: 'book' }"
        >
          <sidebar-item
            v-if="hasRoles(['reviewer'])"
            :link="{
              name: $t('sidebar.review_status'),
              path: '/reviews/status',
            }"
          ></sidebar-item>
          <!-- <sidebar-item
            v-if="hasRoles(['reviewer'])"
            :link="{ name: $t('sidebar.review_done'), path: '/reviews/done' }"
          ></sidebar-item> -->
        </sidebar-item>

        <!-- 총평 관리 -->
        <sidebar-item
          v-if="hasRoles(['editor', 'master'])"
          :link="{
            name: $t('sidebar.final_review_management'),
            icon: 'pageview',
          }"
        >
          <sidebar-item
            v-if="hasRoles(['editor', 'master'])"
            :link="{
              name: $t('sidebar.final_review_status'),
              path: '/final-reviews/status',
            }"
          ></sidebar-item>
          <!-- <sidebar-item v-if="hasRoles(['editor', 'master'])"
            :link="{ name: $t('sidebar.final_review_done'), path: '/final-reviews/done' }"></sidebar-item> -->
        </sidebar-item>

        <!-- 심사위원 관리 -->
        <sidebar-item
          v-if="hasRoles(['editor', 'master'])"
          :link="{
            name: $t('sidebar.reviewer_management'),
            icon: 'manage_accounts',
          }"
        >
          <sidebar-item
            v-if="hasRoles(['editor', 'master'])"
            :link="{
              name: $t('sidebar.reviewer_management_add_and_delete'),
              path: '/reviewers/managements',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasRoles(['editor', 'master'])"
            :link="{
              name: $t('sidebar.reviewer_management_assignment'),
              path: '/reviewers/assignments',
            }"
          ></sidebar-item>
        </sidebar-item>

        <!-- 결제 관리 -->
        <sidebar-item
          :link="{
            name: $t('sidebar.payment_management'),
            icon: 'account_balance_wallet',
          }"
        >
          <sidebar-item
            :link="{ name: $t('sidebar.payment_history'), path: '/payments' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: $t('sidebar.payment_fee'), path: '/payments/fee' }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.payment_donation'),
              path: '/payments/donation',
            }"
          ></sidebar-item>
        </sidebar-item>

        <!-- 투고 관리 -->
        <sidebar-item
          v-if="hasType(['REGULAR', 'ADMIN'])"
          :link="{
            name: $t('sidebar.submission_management'),
            icon: 'edit_square',
          }"
        >
          <!-- 관리자: 전체 투고현황 -->
          <sidebar-item
            v-if="hasType(['ADMIN'])"
            :link="{
              name: $t('sidebar.submission_all_status'),
              path: '/submissions/all',
            }"
          ></sidebar-item>
          <!-- 내 투고관리 (관리자 포함 전체) -->
          <sidebar-item
            v-if="hasType(['REGULAR', 'ADMIN'])"
            :link="{
              name: $t('sidebar.my_submission'),
              path: '/submissions/status',
            }"
          ></sidebar-item>
        </sidebar-item>

        <!-- 게시판 -->
        <sidebar-item :link="{ name: $t('sidebar.board'), icon: 'front_hand' }">
          <sidebar-item
            :link="{
              name: $t('sidebar.announcement'),
              path: '/posts/announcements',
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: $t('sidebar.member_news'),
              path: '/posts/membernews',
            }"
          ></sidebar-item>
        </sidebar-item>

        <!-- 회원관리 -->
        <sidebar-item
          v-if="hasRoles(['member', 'master'])"
          :link="{ name: $t('sidebar.member_management'), icon: 'groups' }"
        >
          <sidebar-item
            v-if="hasRoles(['member', 'master'])"
            :link="{
              name: $t('sidebar.member_info'),
              path: '/members/management',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasRoles(['member', 'master'])"
            :link="{
              name: $t('sidebar.member_approval'),
              path: '/members/approval-reqeust',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasRoles(['master', 'master'])"
            :link="{
              name: $t('sidebar.admin_management'),
              path: '/members/admin-management',
            }"
          ></sidebar-item>
        </sidebar-item>

        <!-- 회계관리 -->
        <sidebar-item
          v-if="hasRoles(['account', 'master'])"
          :link="{ name: $t('sidebar.account_management'), icon: 'paid' }"
        >
          <sidebar-item
            v-if="hasRoles(['account', 'master'])"
            :link="{
              name: $t('sidebar.payment_history'),
              path: '/accounts/payments',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasRoles(['account', 'master'])"
            :link="{
              name: $t('sidebar.fee_type_management'),
              path: '/accounts/fee-types',
            }"
          ></sidebar-item>
        </sidebar-item>

        <!-- 컨텐츠 관리 -->
        <sidebar-item
          v-if="hasRoles(['content', 'master'])"
          :link="{ name: $t('sidebar.content_management'), icon: 'toc' }"
        >
          <sidebar-item
            v-if="hasRoles(['content', 'master'])"
            :link="{
              name: $t('sidebar.homepage_management'),
              path: '/contents/home',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasRoles(['content', 'master'])"
            :link="{
              name: $t('sidebar.announcement_management'),
              path: '/contents/announcements',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasRoles(['content', 'master'])"
            :link="{
              name: $t('sidebar.membernews_management'),
              path: '/contents/member-news',
            }"
          ></sidebar-item>
        </sidebar-item>

        <!-- 저널 관리 -->
        <sidebar-item
          v-if="hasRoles(['content', 'editor', 'master'])"
          :link="{ name: $t('sidebar.journal_management'), icon: 'book' }"
        >
          <sidebar-item
            v-if="hasRoles(['content', 'editor', 'master'])"
            :link="{
              name: $t('sidebar.journal_list'),
              path: '/journals/management',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasRoles(['content', 'editor', 'master'])"
            :link="{
              name: $t('sidebar.consent_document_management'),
              path: '/journals/consent-documents/management',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasRoles(['content', 'editor', 'master'])"
            :link="{
              name: $t('sidebar.journal_archive_management'),
              path: '/journals/archives',
            }"
          ></sidebar-item>
          <!-- <sidebar-item
            v-if="hasRoles(['editor', 'master'])"
            :link="{ name: $t('sidebar.paper_publish_management'), path: '/journals/papers/publish' }"
          ></sidebar-item> -->
          <!-- <sidebar-item
            v-if="hasRoles(['editor', 'master'])"
            :link="{
              name: $t('sidebar.journal_publish_management'),
              path: '/journals/publish',
            }"
          ></sidebar-item> -->
        </sidebar-item>

        <!-- 관리자 페이지 -->
        <sidebar-item
          v-if="hasType(['ADMIN'])"
          :link="{ name: $t('sidebar.admin_page'), icon: 'key' }"
        >
          <sidebar-item
            v-if="hasType(['ADMIN'])"
            :link="{
              name: $t('sidebar.conference_management'),
              path: '/conferences',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasType(['ADMIN'])"
            :link="{
              name: $t('sidebar.conference_archive_management'),
              path: '/admin/conference/archives',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasType(['ADMIN'])"
            :link="{
              name: $t('sidebar.conference_gallery_management'),
              path: '/admin/conference/gallery',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasType(['ADMIN'])"
            :link="{
              name: $t('sidebar.member_archive_management'),
              path: '/admin/member/archives',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasType(['ADMIN'])"
            :link="{
              name: $t('sidebar.mail_template_management'),
              path: '/mail-template',
            }"
          ></sidebar-item>
          <sidebar-item
            v-if="hasType(['ADMIN'])"
            :link="{
              name: $t('sidebar.admin_archive_management'),
              path: '/admin/archives',
            }"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>
      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

import TopNavbar from "@/components/specific/Layout/TopNavbar.vue";
import ContentFooter from "@/components/specific/Layout/ContentFooter.vue";
import UserMenu from "@/components/specific/Layout/Extra/UserMenu.vue";

import { ZoomCenterTransition } from "vue2-transitions";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    UserMenu,
    ZoomCenterTransition,
  },
  data() {
    return {
      sidebarBackgroundColor: "black",
      sidebarBackground: "orange",
      sidebarBackgroundImage: "/img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    hasRoles(requiredRoles) {
      const roles = this.$store.getters["auth/userRoles"] || [];
      return roles.some((role) => requiredRoles.includes(role));
    },
    hasType(requiredTypes) {
      const type = this.$store.getters["auth/userType"] || null;
      return requiredTypes.includes(type);
    },
  },
  updated() {
    reinitScrollbar();
  },
  mounted() {
    reinitScrollbar();
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
  computed: {
    roles() {
      return this.$store.state.auth.roles;
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
